import {get} from '../utils'
import {getActiveChannel, isPublicChannel} from "../authentication/utils";
import localization from "../../../config/localization";

export default host => (channelId, livestreamId) =>
  get(`${host}${isPublicChannel() ? "/public": ""}/channels/${channelId}/livestreams/${livestreamId}?include=translations;video;startImage;endImage;contentCreator;suggestedPlaylist${!getActiveChannel() ? ";allowedRegions" : ""}${getActiveChannel() ? `&cLang=${localization.getLanguage()}` : ""}`)
    .then(response => response.json())
    .then(json => json.data)